import Axios from 'axios';
import Api from './config';
import api from './config';

export function listCustomers(value, rowsPerPage, page, filterByLastUsed, sortByWalkIn, excludeLeads = false) {
    return Api.request({
        method: 'GET',
        url: '/customers',
        params: { value, rowsPerPage, page, filterByLastUsed, sortByWalkIn, excludeLeads }
    });
}

export async function uploadCustomerAvatar(customerId, file) {
    const uploadUrl = await Api.request({
        method: 'GET',
        url: `/customers/${customerId}/upload-url?type=${file.name.split('.')[1]}`
    });

    const signedRequest = uploadUrl.signedRequest;
    const url = uploadUrl.url;

    const options = {
        headers: {
            'Content-Type': file.name.split('.')[1],
            'x-amz-acl': 'public-read'
        }
    };

    // signedRequest, file, options
    await Axios({ url: signedRequest, method: 'PUT', data: file, options });
    return url;
}

export async function getCustomerHistoryLog(id, query) {
    return Api.request({
        method: 'GET',
        url: `/customers/history/${id}?${query}`
    });
}

export async function getMedicalTabsCount(id) {
    return Api.request({
        method: 'GET',
        url: `/customers/medical/${id}`
    });
}
export async function getCustomerById(id) {
    return Api.request({
        method: 'GET',
        url: `/customers/${id}`
    });
}

export function sendEmail(customerId, data) {
    return api.request({
        method: 'POST',
        url: `/customer/send-email/${customerId}`,
        data
    });
}

export function checkDuplicate({ email, phone }) {
    return Api.request({
        method: 'GET',
        url: '/customers/check-duplicate',
        params: { email, phone }
    });
}

export function sendSms(customerId, data) {
    return api.request({
        method: 'POST',
        url: `/customer/send-sms/${customerId}`,
        data
    });
}
